module.exports = __webpack_public_path__ + "static/img/sign.f434c6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/sign.png
// module id = rF/n
// module chunks = 1